import React from 'react';
import { Suggestion } from '@components/common/Suggestion';
import { useShopStage } from '@hooks';
import { useCurrentShopQuery } from '@modules/Dashboard/hooks/useCurrentShopQuery';
import { useSocialLinksQuery } from '@modules/ThemeEditorV2/modules/SocialLinks';
import { routing } from '@utils/routing';
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss';
import addSocialLinks from '../assets/add-social-links.png';
export const useSocialLinksRecommendation = () => {
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    const { shopStage, isLoading: isLoadingShopStage } = useShopStage();
    const { currentShopQuery } = useCurrentShopQuery();
    const { socialLinksQuery } = useSocialLinksQuery([currentShopQuery.data?.id], {
        enabled: currentShopQuery.isSuccess && !!currentShopQuery.data.id,
        staleTime: 60_000,
    });
    return {
        socialLinksRecommendation: {
            id: 'socialLinks',
            enabled: shopStage.stage2 &&
                socialLinksQuery.isSuccess &&
                !!socialLinksQuery.data.socialNetworks.length &&
                recommendationsDismiss.social.visible,
            isLoading: isLoadingShopStage ||
                currentShopQuery.isInitialLoading ||
                socialLinksQuery.isInitialLoading,
            suggestion: (React.createElement(Suggestion, { title: "Add social links", description: "Feature Instagram, Twitch, TikTok, and YouTube on your page.", buttonLabel: "Add social links", buttonTo: routing.themeEditorV2.general.socialLinks, imageUrl: addSocialLinks, analytics: "addSocialLinks", onDismiss: createOnDismiss(recommendationsDismiss.social.dismiss) })),
        },
    };
};
